<template>
    <div>
        <vue-headful
                title="Ponderosa Software | Impressum"
                description="Offizielles Impressum der Ponderosa Software"
        />
        <md-card md-with-hover>
            <md-ripple>
                <md-card-header>
                    <div class="md-title">Impressum</div>
                    <div class="md-subhead">Herausgeber und verantwortlich für den Inhalt dieser Seite:</div>
                </md-card-header>

                <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-50 md-xsmall-size-100">
                            <table border="0" cellpadding="0" cellspacing="0">
                                <tr><td colspan="3"><b>Ponderosa Software UG</b></td></tr>
                                <tr><td colspan="3">(haftungsbeschränkt)</td></tr>
                                <tr><td colspan="3">Bernburger Straße 27</td></tr>
                                <tr><td colspan="3">06108 Halle (Saale)</td></tr>
                                <tr><td colspan="3">Deutschland</td></tr>
                                <tr><td colspan="3">&nbsp;</td></tr>
                                <tr>
                                    <td>Tel:</td>
                                    <td class="table-space-left"></td>
                                    <td>+49 177 2358270</td>
                                </tr>
                                <tr>
                                    <td>E-Mail:</td>
                                    <td class="table-space-left"></td>
                                    <td>info@ponderosa-software.de</td>
                                </tr>
                            </table>
                        </div>
                        <div class="md-layout-item md-size-50 md-xsmall-size-100">
                            <table border="0" cellpadding="0" cellspacing="0">
                                <tr><td colspan="3">&nbsp;</td></tr>
                                <tr>
                                    <td>Steuernummer:</td>
                                    <td class="table-space-right"></td>
                                    <td>110/107/45189</td>
                                </tr>
                                <tr>
                                    <td>Umsatzsteuer-ID:</td>
                                    <td class="table-space-right"></td>
                                    <td>DE293611124</td>
                                </tr>
                                <tr>
                                    <td>Handelsregister:</td>
                                    <td class="table-space-right"></td>
                                    <td>Stendal HRB 20332</td>
                                </tr>
                                <tr>
                                    <td>Geschäftsführer:</td>
                                    <td class="table-space-right"></td>
                                    <td>Falk Huth</td>
                                </tr>
                                <tr><td colspan="3">&nbsp;</td></tr>
                                <tr>
                                    <td>Ansprechpartner:</td>
                                    <td class="table-space-right"></td>
                                    <td>Falk Huth</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </md-card-content>
                <md-divider></md-divider>
                <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-50 md-xsmall-size-100">
                            <div class="md-body-1">
                                Rechnungsstellung für <b>DJ Falk</b> alias Herr Falk
                            </div>
                            <div class="md-body-1 link-div">
                                <md-icon class="page-icon">open_in_new</md-icon>
                                <a href="https://www.dj-falk.de" target="_blank">www.dj-falk.de</a>
                            </div>
                        </div>
                        <div class="md-layout-item md-size-50 md-xsmall-size-100">
                            <div class="md-body-1">
                                Privatperson <b>Falk Huth</b> und seine bisherigen IT-Projekte
                            </div>
                            <div class="md-body-1 link-div">
                                <md-icon class="page-icon">open_in_new</md-icon>
                                <a href="https://www.falk-huth.de" target="_blank">www.falk-huth.de</a>
                            </div>
                        </div>
                    </div>
                </md-card-content>
            </md-ripple>
        </md-card>
    </div>
</template>

<script>
    export default {
        name: "Impressum"
    }
</script>

<style lang="scss" scoped>
    .md-subheader {
        padding-left: 0!important;
    }
    .link-div {
        margin-top: 12px;
    }
    .second-link {
        margin-top: 42px;
    }
    .page-icon {
        padding-left: 50px;
        padding-right: 20px;
    }
    .table-space-left {
        width: 20px;
    }
    .table-space-right {
        width: 10px;
    }
</style>
